/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Properties of an AWS Redshift cluster or serverless workgroup. Present only when `resourceType` is set to `AWS_REDSHIFT`. 
*/
export class AwsRedshiftResource {
  /**
  * The cluster identifier or workgroup name.
  */
  'clusterIdentifier': string;
  /**
  * Whether this is a provisioned cluster or serverless workgroup.
  */
  'clusterType'?: AwsRedshiftResourceClusterTypeEnum;
  /**
  * The node type for provisioned clusters.
  */
  'nodeType'?: string;
  /**
  * The number of nodes in a provisioned cluster.
  */
  'numberOfNodes'?: number;
  /**
  * The current status of the cluster or workgroup.
  */
  'status'?: string;
  /**
  * The endpoint address for connections.
  */
  'endpoint'?: string;
  /**
  * The port number for connections.
  */
  'endpointPort'?: number;
  /**
  * The default database name.
  */
  'dbName'?: string;
  /**
  * The VPC that the cluster is in.
  */
  'vpcId'?: string;
  /**
  * Whether the cluster is encrypted at rest.
  */
  'encrypted'?: boolean;
  /**
  * The ARN of the KMS key used for encryption.
  */
  'kmsKeyId'?: string;
  /**
  * The display name of the cluster or workgroup.
  */
  'name'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "clusterIdentifier",
      "baseName": "clusterIdentifier",
      "type": "string",
      "format": ""
    },
    {
      "name": "clusterType",
      "baseName": "clusterType",
      "type": "AwsRedshiftResourceClusterTypeEnum",
      "format": ""
    },
    {
      "name": "nodeType",
      "baseName": "nodeType",
      "type": "string",
      "format": ""
    },
    {
      "name": "numberOfNodes",
      "baseName": "numberOfNodes",
      "type": "number",
      "format": ""
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "string",
      "format": ""
    },
    {
      "name": "endpoint",
      "baseName": "endpoint",
      "type": "string",
      "format": ""
    },
    {
      "name": "endpointPort",
      "baseName": "endpointPort",
      "type": "number",
      "format": ""
    },
    {
      "name": "dbName",
      "baseName": "dbName",
      "type": "string",
      "format": ""
    },
    {
      "name": "vpcId",
      "baseName": "vpcId",
      "type": "string",
      "format": ""
    },
    {
      "name": "encrypted",
      "baseName": "encrypted",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "kmsKeyId",
      "baseName": "kmsKeyId",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsRedshiftResource.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum AwsRedshiftResourceClusterTypeEnum {
  Provisioned = 'provisioned',
  Serverless = 'serverless'
}

